export default "__VITE_ASSET__a1a15bfe__"